import React from "react";
import dayjs from "dayjs";

import { MessageType } from "./Message";

function LocationMessage(props) {
  const googleMapsAPIKey = "AIzaSyBSUwGhZOqKroutZ0dSV_JwELEfp2oO2yI";
  const getStaticMapURL = () => {
    return (
      "https://maps.googleapis.com/maps/api/staticmap?center=" +
      props.message.message.text +
      "&zoom=12&size=400x400&maptype=roadmap&format=png&visual_refresh=true&key=" +
      googleMapsAPIKey
    );
  };

  const showMessageTime = () => {
    return props.message.type !== MessageType.info;
  };

  const messageTimeClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  const messageBoxClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return "s360-message-box-received";
      case MessageType.info:
        return "s360-message-box-info";
      default:
        return "";
    }
  };

  const messageContainerClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  const messageBoxStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.sent:
        return {
          height: "105px",
          ...config?.customDesign?.locationMessageBoxReceiver
        };
      case MessageType.received:
        return {
          height: "105px",
          ...config?.customDesign?.locationMessageBoxSender
        };
      default:
        return {};
    }
  };

  const messageTimeStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
      case MessageType.sent:
      case MessageType.info:
        return config?.customDesign?.locationMessageTime;
      default:
        return {};
    }
  };

  return (
    <div className={messageContainerClassName()}>
      <div className={messageBoxClassName()} style={messageBoxStyle()}>
        <a href={`https://www.google.com/maps/place/${props.message.message.text}`} rel="noreferrer" target="_blank">
          <img
            src={getStaticMapURL()}
            width="100%"
            height="100%"
            alt="Map"
          />
          <br />
        </a>
      </div>
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {showMessageTime() && (
          <div
            className={messageTimeClassName()}
            style={messageTimeStyle()}
          >
            {dayjs
              .unix(
                Math.trunc(
                  this?.props?.message?.message?.sentTimestamp / 1000
                )
              )
              .format("DD MMM h:mm a")}
          </div>
        )}

        {/* <Retry {...props} /> */}
      </div>
    </div>
  );
}

export default LocationMessage;
